import { UserPlus, Heart, MapPin, Sparkles } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";

const suggestions = [
  { name: 'Sarah M.', initial: 'S', reason: 'Attending same events' },
  { name: 'Maya K.', initial: 'M', reason: 'Nearby & similar interests' },
];

export const DemoFriends = () => {
  return (
    <Card className="p-4 bg-card/95 backdrop-blur-sm border-border/50 space-y-4">
      <div className="flex items-center gap-2 text-sm text-primary">
        <Sparkles className="w-4 h-4" />
        <span className="font-medium">Friend Suggestions</span>
      </div>
      
      <div className="space-y-3">
        {suggestions.map((suggestion, index) => (
          <div 
            key={index}
            className="flex items-center gap-3 p-3 rounded-lg bg-muted/50"
          >
            <Avatar className="w-10 h-10">
              <AvatarFallback className="bg-primary/20 text-primary">
                {suggestion.initial}
              </AvatarFallback>
            </Avatar>
            
            <div className="flex-1 min-w-0">
              <p className="font-medium text-sm text-foreground">{suggestion.name}</p>
              <p className="text-xs text-muted-foreground flex items-center gap-1">
                {index === 0 ? <Heart className="w-3 h-3" /> : <MapPin className="w-3 h-3" />}
                {suggestion.reason}
              </p>
            </div>
            
            <Button size="sm" variant="outline" className="shrink-0">
              <UserPlus className="w-3.5 h-3.5 mr-1" />
              Add
            </Button>
          </div>
        ))}
      </div>
      
      <p className="text-xs text-center text-muted-foreground">
        Connect with people who share your wellness journey
      </p>
    </Card>
  );
};
